import { render, staticRenderFns } from "./Cinemas.vue?vue&type=template&id=33ee4d31&scoped=true"
import script from "./Cinemas.vue?vue&type=script&lang=js"
export * from "./Cinemas.vue?vue&type=script&lang=js"
import style0 from "./Cinemas.vue?vue&type=style&index=0&id=33ee4d31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee4d31",
  null
  
)

export default component.exports